/**
 * changePage.js
 * Written by: Alex Kasemir
 */

export const changePage = (category, key, value) => ({
  type: `CHANGE_PAGE`,
  category,
  key,
  value,
});

